import Vue from 'vue'

export default {
  text : {
    "main_title": 'Shopping cart',
    "billing-address" : "Billing address",
    "orders-customer": "Orders",

    "option-yes": "Yes",
    "option-no": "No",

    "dayNames" : ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Sathurday"],
    "dayNamesShort" : ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],

    "cart-is-empty": "The cart is empty",
    "product-question-delete": "Do you really want to remove this product from the cart?",

    "button-login-continue": "Continue",
    "login-info-line-1": "Login email is on its way to <span>%1</span>.",
    "login-info-line-2": "You can open it at a different device and return here.",
    "button-login-send-again": "Resend code",
    "button-login-reset": "Wrong email?",
    "login-welcome": "Wellcome back, %0!",
    "login-rules": 'By signing in, I accept <a target="_blank" href="%0">terms & conditions</a>',
    "login-newsletter": 'I`d like to get sometimes your <a target="_blank" href="%0">newsletter</a>',
    "login-code-error": "Code is not valid.",
    "": "",
    "": "",
    "": "",
    "": "",
    "": "",
    "": "",
    "": "",
    "": "",
    "": "",
    "": "",

    "delivery-slots-info": "Only %0 minutes left to make the order.",
    "delivery-slot-no-longer-available": "Selected delivery time slot is no longer available. Choose another one.",
    "": "",

    "invoice-note": "Invoice note",
    "": "",
    "": "",
    "": "",

    "NO_CART_ID": "No cart identification.",
    "NO_PROD_LEFT": "There is not that many products available.",
  }
}
